import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from '@material-ui/icons/Info';
import DialogSummary from "./DialogSummary";
import {
  IconButton,
  Typography
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonSummary({ project,label='' }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>     
      {project&&(
        <>
        {label!=''&&<Typography variant="body2" style={{ marginRight: '8px' }} onClick={handleOnOpen}>{label}</Typography>}
        <IconButton onClick={handleOnOpen} color="primary" title="Project Summary">
          <InfoIcon/>
        </IconButton>      
        </>
      )}
      
      <DialogSummary
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        project={project}
      />
    </>
  );
}
